import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook to create a guided tour for the Groups and Memberships page
 * Uses Driver.js to highlight elements and show explanations
 */
export function useGroupsTour() {
    const { t } = useTranslation();

    const startTour = useCallback(() => {
        const driverObj = driver({
            showProgress: true,
            animate: true,
            allowClose: true,
            stagePadding: 4,
            nextBtnText: t('tour.next'),
            prevBtnText: t('tour.back'),
            doneBtnText: t('tour.last'),
            progressText: '{{current}} / {{total}}',
            steps: [
                {
                    popover: {
                        title: t('tour.groups.intro.title'),
                        description: t('tour.groups.intro.description'),
                    },
                },
                {
                    element: '#fab-add-button',
                    popover: {
                        title: t('tour.groups.addButton.title'),
                        description: t('tour.groups.addButton.description'),
                        side: 'top',
                        align: 'end',
                    },
                },
                {
                    element: 'table tbody tr td:first-child a',
                    popover: {
                        title: t('tour.groups.groupName.title'),
                        description: t('tour.groups.groupName.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: 'input[type="text"]',
                    popover: {
                        title: t('tour.groups.nameFilter.title'),
                        description: t('tour.groups.nameFilter.description'),
                        side: 'bottom',
                        align: 'start',
                    },
                },
                {
                    element: '#filter-button',
                    popover: {
                        title: t('tour.groups.filterButton.title'),
                        description: t('tour.groups.filterButton.description'),
                        side: 'bottom',
                        align: 'end',
                    },
                },
            ],
        });

        driverObj.drive();
    }, [t]);

    return { startTour };
}
